export enum moduleLoadingNames {
  SET_LOADING = "SET_LOADING",
}
